<script setup lang="ts">
import { inject, Ref } from 'vue';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const description = dialogRef?.value?.data?.description;
const isAlignCenter = dialogRef?.value?.data?.isAlignCenter;
const onClose = dialogRef.value.options.emits.onClose;

const selectClose = () => {
  onClose();
};
</script>
<template>
  <div class="error-modal">
    <div :class="['header', { 'text-center': isAlignCenter }]" class="error-text text-primary">
      <p class="text-lg text-start bold-style">{{ description }}</p>
    </div>
    <div class="flex justify-content-center mt-4">
      <Button class="close-btn" :label="$t('common.buttons.close')" @click="selectClose()"></Button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.error-modal {
  z-index: 9999;
}
</style>
